import { createStore, type StoreConfig } from './state-helper'

type PAWStore = {
  tier: string
  date: Record<string, number>
  dateLabel?: string

  setDate: (date: { month?: number; year: number }) => void
  setTier: (tier: string) => void

  setDateLabel: (label: string) => void

  reset: () => void
}

const initialState = {
  tier: '',
  date: {
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
  },
  dateLabel: '',
}

const pawStore: StoreConfig<PAWStore> = (set) => ({
  ...initialState,

  setDate: (date: { month?: number; year: number }) => {
    set({ date })
  },

  setTier: (tier: string) => {
    set({ tier })
  },

  setDateLabel: (label: string) => {
    set({ dateLabel: label })
  },

  reset: () => {
    set(initialState)
  },
})

export const usePAWStore = createStore(pawStore, {
  name: 'paw_storage',
})
